export const FILTER_LIST_HEIGHT = '260px';
export const SEARCH_PLACEHOLDER = 'Search...';
